// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"822ab2ff","132":"4fe52d63","243":"8e8b07de","438":"ef633899","488":"49d7f9c1","508":"70a9e6ce","771":"503fe7ba","861":"7ad548d6","942":"319e34b6"}[chunkId] + ".chunk.js";
};